/* global Excel */

import { applyBorders } from "@/utils/macro";

export async function avgifsMultiCriteria(context: Excel.RequestContext) {
  const vividPink = "#D549B4";
  const sheetName = "Averageifs Multi Criteria";
  const sheets = context.workbook.worksheets;
  const existingSheet = sheets.getItemOrNullObject(sheetName);
  existingSheet.load("name");
  await context.sync();

  if (!existingSheet.isNullObject) {
    existingSheet.delete();
    await context.sync();
  }

  const sheet = sheets.add(sheetName);
  sheet.activate();

  const data = [
    ["Sales Amount", "Salesperson", "Sales ID", "Month", "Region"],
    [7000, "Colin", 53001, "October", "West"],
    [45000, "Mike", 53002, "October", "West"],
    [14000, "Diane", 53003, "October", "East"],
    [6000, "Wendy", 53004, "October", "East"],
    [20000, "Mike", 53005, "October", "West"],
    [5000, "Diane", 53006, "October", "East"],
    [8000, "Colin", 53007, "November", "West"],
    [9000, "Colin", 53008, "November", "West"],
    [6000, "Colin", 53009, "November", "West"],
    [34000, "Diane", 53010, "November", "East"],
    [12000, "Diane", 53011, "November", "East"],
    [40000, "Wendy", 53012, "November", "East"],
    [3000, "Wendy", 53013, "December", "East"],
    [15000, "Mike", 53014, "December", "West"],
    [16000, "Mike", 53015, "December", "West"],
    [12000, "Diane", 53016, "December", "East"],
    [18000, "Colin", 53017, "December", "West"],
    [50000, "Diane", 53018, "December", "East"],
    [19000, "Mike", 53019, "December", "West"],
  ];

  const tableRange = sheet.getRange("A1:E20");
  tableRange.values = data;
  tableRange.format.autofitColumns();
  tableRange.format.font.name = "Aptos Display";

  const description = sheet.getRange("F:N");
  description.format.font.name = "Arial";

  const header = sheet.getRange("A1:E1");
  header.format.font.bold = true;
  header.format.font.size = 12;
  header.format.horizontalAlignment = "Center";
  applyBorders(header, [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G1").values = [["Formula"]];
  sheet.getRange("G1").format.font.bold = true;
  sheet.getRange("G1").format.horizontalAlignment = "Center";

  const salesPersonCell = sheet.getRange("I1");
  salesPersonCell.values = [["Salesperson"]];
  salesPersonCell.format.font.bold = true;
  salesPersonCell.format.horizontalAlignment = "Center";
  applyBorders(salesPersonCell, [Excel.BorderIndex.edgeBottom]);

  const salesPersonValue = sheet.getRange("I2");
  salesPersonValue.values = [["Colin"]];
  salesPersonValue.format.horizontalAlignment = "Center";
  salesPersonValue.format.font.color = "purple";
  salesPersonValue.format.font.bold = true;

  const monthCell = sheet.getRange("J1");
  monthCell.values = [["Month"]];
  monthCell.format.font.bold = true;
  monthCell.format.horizontalAlignment = "Center";
  applyBorders(monthCell, [Excel.BorderIndex.edgeBottom]);

  const monthValue = sheet.getRange("J2");
  monthValue.values = [["November"]];
  monthValue.format.horizontalAlignment = "Center";
  monthValue.format.font.color = vividPink;
  monthValue.format.font.bold = true;

  const formulaCell = sheet.getRange("G2");
  formulaCell.formulas = [["=AVERAGEIFS($A$2:$A$20,$B$2:$B$20,$I$2,$D$2:$D$20,$J$2)"]];
  formulaCell.format.fill.color = "#FFFF00";
  formulaCell.format.font.bold = true;
  formulaCell.numberFormat = [["$#,##0"]];
  formulaCell.format.horizontalAlignment = "Center";
  applyBorders(formulaCell, undefined, undefined, Excel.BorderWeight.medium);

  sheet.getRange("G4").values = [["Formula Purpose"]];
  sheet.getRange("G5").setCellProperties([
    [
      {
        textRuns: [
          {
            text: "To Average the Total Sales that Colin made in November",
          },
          { text: " ONLY", font: { bold: true } },
        ],
      },
    ],
  ]);
  sheet.getRange("G4").format.font.bold = true;

  const formulaLogicRange = sheet.getRange("G4:L4");
  sheet.getRange("G7").values = [["Formula Logic"]];
  sheet.getRange("G7").format.font.bold = true;
  sheet.getRange("G8").numberFormat = [["@"]];
  sheet.getRange("G8").setCellProperties([
    [
      {
        textRuns: [
          { text: "=AVERAGEIFS(", font: { color: "black" } },
          { text: "average_range", font: { color: "blue" } },
          { text: ",", font: { color: "black" } },
          { text: "criteria_range1", font: { color: "red" } },
          { text: "," },
          { text: "criteria1", font: { color: "purple" } },
          { text: ",[" },
          { text: "criteria_range2", font: { color: "green" } },
          { text: "," },
          { text: "criteria2", font: { color: vividPink } },
          { text: "])", font: { color: "black" } },
        ],
      },
    ],
  ]);
  applyBorders(formulaLogicRange, [Excel.BorderIndex.edgeBottom]);
  applyBorders(sheet.getRange("G7:L7"), [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G10").values = [["Sample Formula Inputs"]];
  sheet.getRange("G10").format.font.bold = true;
  sheet.getRange("G11").numberFormat = [["@"]];
  sheet.getRange("G11").setCellProperties([
    [
      {
        textRuns: [
          { text: "=AVERAGEIFS(" },
          {
            text: "$A$2:$A$20",
            font: { color: "blue" },
          },
          { text: "," },
          {
            text: "$B$2:$B$20",
            font: { color: "red" },
          },
          { text: "," },
          {
            text: "$I$2",
            font: { color: "purple" },
          },
          { text: "," },
          {
            text: "$D$2:$D$20",
            font: { color: "green" },
          },
          { text: "," },
          {
            text: "$J$2",
            font: { color: vividPink },
          },
          { text: ")" },
        ],
      },
    ],
  ]);
  applyBorders(sheet.getRange("G10:L10"), [Excel.BorderIndex.edgeBottom]);

  sheet.getRange("G13").values = [["SheetShark Summary:"]];
  sheet.getRange("G13").format.font.bold = true;

  sheet.getRange("G14").setCellProperties([
    [
      {
        textRuns: [
          { text: "The formula calculates the average of values in the range" },
          {
            text: " A2",
            font: { color: "blue", bold: true },
          },
          { text: " to" },
          {
            text: " A20",
            font: { color: "blue", bold: true },
          },
          { text: " but only" },
        ],
      },
    ],
  ]);

  sheet.getRange("G15").setCellProperties([
    [
      {
        textRuns: [{ text: "includes those values that meet two specific conditions. The first condition is that" }],
      },
    ],
  ]);

  sheet.getRange("G16").setCellProperties([
    [
      {
        textRuns: [
          { text: "the corresponding value in the range" },
          {
            text: " B2",
            font: { color: "red", bold: true },
          },
          { text: " to" },
          {
            text: " B20",
            font: { color: "red", bold: true },
          },
          { text: " must match the value in cell" },
          {
            text: " I2.",
            font: { color: "purple", bold: true },
          },
        ],
      },
    ],
  ]);

  sheet.getRange("G17").setCellProperties([
    [
      {
        textRuns: [
          { text: "The second condition is that the corresponding value in the range" },
          {
            text: " D2",
            font: { color: "green", bold: true },
          },
          { text: " to" },
          {
            text: " D20",
            font: { color: "green", bold: true },
          },
          { text: " must" },
        ],
      },
    ],
  ]);

  sheet.getRange("G18").setCellProperties([
    [
      {
        textRuns: [
          { text: "match the value in cell" },
          {
            text: " J2.",
            font: { color: vividPink, bold: true },
          },
          { text: " If both conditions are met for a particular row, the value" },
        ],
      },
    ],
  ]);

  sheet.getRange("G19").setCellProperties([
    [
      {
        textRuns: [
          { text: "from column" },
          {
            text: " A",
            font: { color: "blue", bold: true },
          },
          { text: " for that row is included in the sum." },
        ],
      },
    ],
  ]);
  applyBorders(sheet.getRange("G13:L19"));

  // Set all columns to a certain width for consistency
  sheet.getUsedRange().getEntireColumn().format.columnWidth = 80;

  // Center align B, C, D, E columns
  sheet.getRange("B:E").format.horizontalAlignment = "Center";

  // Format "Sales Amount" with currency prefix and two decimals
  sheet.getRange("A2:A20").numberFormat = [['_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)']];
  // Format "Formula" with currency prefix with no decimal
  sheet.getRange("G2").numberFormat = [['_($* #,##0_);_($* (#,##0.00);_($* "-"??_);_(@_)']];

  await context.sync();
}
